/*
 * AIzaSyBqpKmu9t-LRc1aNlKv9lDSra3m01XT8tw
 */

import ScrollReveal from 'scrollreveal';

jQuery(function ($) {
  var _oldShow = $.fn.show;

  $.fn.show = function (speed, oldCallback) {
    return $(this).each(function () {
      var obj = $(this),
        newCallback = function () {
          if ($.isFunction(oldCallback)) {
            oldCallback.apply(obj);
          }
          obj.trigger('afterShow');
        };

      // you can trigger a before show if you want
      obj.trigger('beforeShow');

      // now use the old function to show the element passing the new callback
      _oldShow.apply(obj, [speed, newCallback]);
    });
  };
});

(function ($) {
  'use strict';

  var cubbi = {
    window: $(window),
    small_max_width: 375,
    medium_start_width: 376,

    init: function (settings) {
      cubbi.type_effect();
      cubbi.basic_tab();
      cubbi.small_view();
      cubbi.medium_view();
    },

    small_view: function () {
      if (cubbi.window.width() <= cubbi.small_max_width) {
        cubbi.tour_step();
      }
    },

    medium_view: function () {
      if (cubbi.window.width() >= cubbi.medium_start_width) {
        cubbi.tour_slider();
      }
    },

    /* tour slider */
    tour_slider: function () {
      $('.tour-steps').slick({
        dots: true,
        arrows: true,
        autoplay: false,
        autoplaySpeed: 2000,
      });
    },

    /* Tour steps */
    tour_step: function () {
      var tourStep = $('.tour-steps > div'),
        tourLength = tourStep.length;

      tourStep.each(function (i, v) {
        var tour = $(this);
        var tourID = 'tour_step_';
        var html = '';

        tour.addClass('tour-step');

        var title = tour.next().find('h3').html();

        tour.attr('id', tourID + i);
        html += "<div class='text-center'>";
        html +=
          "<div class='tour-page-numbers'> " +
          (i + 1) +
          ' of ' +
          tourLength +
          '</div>';
        if (tourLength > i + 1) {
          html +=
            "<div class='tour-nav'>Next: " +
            title +
            ' <a class="tour-next" href="#' +
            tourID +
            (i + 1) +
            '"><i class="icon-down-arrow"></i></a></div>';
        } else {
          html += '<div>End of Tour</div>';
        }

        html += '</div>';

        tour.append(html);
      });

      $('.tour-next').click(function () {
        var elem = $(this);
        var target_element = elem.attr('href');

        $(target_element).fadeIn();

        $('html, body').animate(
          {
            scrollTop: $(target_element).offset().top,
          },
          1000,
        );

        return false;
      });
    },

    /* basic tab */

    basic_tab: function () {
      /* Basic Tab  */

      $('.tab-control-wrap .tab-control').click(function () {
        var tab_id = $(this).attr('data-tab');

        $('.tab-control-wrap .tab-control').removeClass('current');
        $('.tab-content').removeClass('current');

        $(this).addClass('current');
        $('#' + tab_id).addClass('current');

        $('.how-it-works-slider').slick('unslick');
        console.log('#' + tab_id);
        $('#' + tab_id + '-slick').slick({
          dots: true,
          arrows: true,
          autoplay: true,
          autoplaySpeed: 2000,
        });
      });
    },

    type_effect: function () {
      // type js

      if ($('#typedSubtitle').length > 0) {
        var sentences = $('#typedSubtitle').attr('data-sentences');

        if (sentences) {
          sentences = sentences.split('|');

          $('#typedSubtitle').typed({
            strings: sentences,
            showCursor: false,
            typeSpeed: 30,
          });
        }
      }
    },
  };

  $(document).ready(cubbi.init);
})(jQuery);

jQuery(document).ready(function ($) {
  var sr = ScrollReveal();

  $('.sidebar-sticky').stickySidebar({
    topSpacing: 10,
    bottomSpacing: 0,
    containerSelector: '.wrapper.fixed',
    innerWrapperSelector: '.sideber-inner',
  });

  // click on scroll target

  $('.click-sroll-target').click(function () {
    var elem = $(this);
    var target = elem.attr('href');

    $('html, body').animate(
      {
        scrollTop: $(target).offset().top,
      },
      1000,
    );
  });

  function getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  function getRandomFloat(min, max) {
    return (Math.random() * (min - max) + max).toFixed(2);
  }

  $('.menu-toggle').click(function () {
    $('body').toggleClass('toggled');
  });

  $('[data-bg]').each(function () {
    var elem = $(this);
    var bgSrc = elem.attr('data-bg');

    elem.css({
      'background-image': 'url(' + bgSrc + ')',
    });
  });

  $('.how-it-works-slider').slick({
    dots: true,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 2000,
  });

  /* scroll reveal start */

  var hero_phone = {
      scale: 1,
      delay: 1000,
      duration: 500,
      origin: 'right',
      distance: '100px',
    },
    hero_tagline = {
      scale: 1,
      origin: 'bottom',
      distance: '40px',
    },
    hero_badge = {
      scale: 1,
      origin: 'bottom',
      distance: '40px',
      delay: 500,
    },
    smallHeader = {
      scale: 1,
      origin: 'bottom',
      distance: '20px',
      delay: 800,
      rotate: {
        x: 0,
        y: 0,
        z: 0,
      },
    },
    largerHeader = {
      scale: 1,
      origin: 'bottom',
      distance: '20px',
      delay: 400,
      rotate: {
        x: 0,
        y: 0,
        z: 0,
      },
    },
    sectionContent = {
      scale: 1,
      origin: 'bottom',
      distance: '20px',
      delay: 700,
      duration: 300,
      rotate: {
        x: 0,
        y: 0,
        z: 0,
      },
    },
    btnCta = {
      scale: 0.9,
      delay: 600,
    },
    signup_stats_panel = {
      scale: 0.9,
      delay: 1000,
      afterReveal: function (domEl) {
        statsTenants.innerHTML = 4910;
        statsLandlords.innerHTML = 3148;
        statsProperties.innerHTML = 3777;
      },
    };
  signup_stats_panel = {
    scale: 0.9,
    delay: 1000,
    afterReveal: function (domEl) {
      statsSavings.innerHTML = 26724300;
    },
  };

  sr.reveal('h1.tagline', hero_tagline);
  sr.reveal('.up-sr', hero_phone);
  sr.reveal('.hero-review-badge', hero_badge);

  $('.bubbles span').each(function () {
    var elem = $(this);
    var randomScaleVal = getRandomFloat(0, 1);
    sr.reveal(elem, {
      scale: randomScaleVal,
      distance: 0,
      delay: getRandomInt(1000, 1500),
    });
  });

  $('.landlords-photo-section span').each(function (i) {
    i++;
    var elem = $(this);
    var d = i * 500;
    sr.reveal(elem, {
      scale: 0.5,
      distance: 0,
      delay: d,
    });
  });

  /* reveal section content */

  /* scroll small header */

  sr.reveal('.sr-small-header', smallHeader);
  sr.reveal('.sr-large-header', largerHeader);
  sr.reveal('.sr-content', sectionContent);

  sr.reveal('.sr-btn-cta', btnCta);

  /* Testimonials */

  function groupedSrReveal(elements, fr_origin) {
    fr_origin = typeof fr_origin !== 'undefined' ? fr_origin : 'bottom';
    elements.each(function (i) {
      i++;
      var elem = $(this);
      var d = i * 120;

      sr.reveal(elem, {
        scale: 1,
        origin: fr_origin,
        distance: '40px',
        delay: d,
      });
    });
  }

  groupedSrReveal($('.section-about-items > div'));

  groupedSrReveal($('.no-slider .testimonials .testimonial-wrap'));

  groupedSrReveal($('.faq-accordion-animate > div'), 'left');

  groupedSrReveal($('.team .team-member-wrap'));

  groupedSrReveal($('.protection-container .protection-widget-wrap'));

  /* Testimonials */

  $('.testimonial').slick({
    dots: true,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 5000,
  });

  /* Accordion  */

  $('.faq-accordion [data-accordion]').accordion({
    transitionSpeed: 300,
  });

  /*
      property slider
  */

  // $('.property-slider').on('click', function () {
  //   console.log("rer");
  //   $('body').addClass('open-modal');
  // });

  $('.image-slider').slick();

  var galleryInit;
  $('.property-slider .slick-slide').on('click', function () {
    $('body').addClass('open-modal');
    // open gallery
    console.log(galleryInit);
    if (galleryInit === undefined) {
      galleryInit = $('.pgwSlideshow').pgwSlideshow({});
    }
  });

  // navigate to properly show page when clicking on property item
  $('.explore-property-widget .image-slider').on('click', function () {
    window.location.href = $(this)
      .parents('.explore-property-widget')
      .find('a')
      .attr('href');
  });

  $('.gallery_modal .close').click(function () {
    $('body').removeClass('open-modal');
  });

  /* Stats */

  var statsTenants = document.querySelector('.stats-tenants');
  var statsLandlords = document.querySelector('.stats-landlords');
  var statsProperties = document.querySelector('.stats-properties');
  var statsSavings = document.querySelector('.stats-savings');

  if (statsTenants) {
    od_statsTenants = new Odometer({
      el: statsTenants,
      value: 0,

      // Any option (other than auto and selector) can be passed in here
      format: '(,ddd)',
      theme: 'minimal',
    });
  }

  if (statsLandlords) {
    od_statsLandlords = new Odometer({
      el: statsLandlords,
      value: 0,

      // Any option (other than auto and selector) can be passed in here
      format: '(,ddd)',
      theme: 'minimal',
    });
  }

  if (statsTenants) {
    od_statsProperties = new Odometer({
      el: statsProperties,
      value: 0,

      // Any option (other than auto and selector) can be passed in here
      format: '(,ddd)',
      theme: 'minimal',
    });
  }

  if (statsSavings) {
    od_statsSavings = new Odometer({
      el: statsSavings,
      value: 0,

      // Any option (other than auto and selector) can be passed in here
      format: '(,ddd)',
      theme: 'minimal',
    });
  }

  sr.reveal('.signup .panel-white', signup_stats_panel);

  $('.animate-to-link').click(function () {
    var elem = $(this);
    var target_element = elem.attr('href');

    $(target_element).fadeIn();

    console.log(target_element);
    $('html, body').animate(
      {
        scrollTop: $(target_element).offset().top,
      },
      1000,
    );

    return false;
  });

  $('.search-mobile-icon').click(function () {
    $('.search-mobile').show();
  });

  $('.search-mobile .close').click(function () {
    $('.search-mobile').hide();
  });
});
